import React, { PropTypes } from 'react';
import cx from './MostActive.scss';
import GoalCardWrapper from 'components/GoalCard/Wrapper';
import Avatar from 'components/Avatar';
import Spinner from 'components/Spinner';
import { get } from 'utils/request';
import BlockHeader from './BlockHeader';
import { declension } from 'utils/lang';

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class MostActive extends React.Component {

	static propTypes = {
		initialData: PropTypes.array,
	};

	state = {
		filter: 'week',
		data: {
			week: this.props.initialData,
		},
	};

	constructor(props, context) {
		super(props, context);

		if(!props.initialData) {
			this.handleNav('week');
		}
	}

	async handleNav(filter) {
		this.setState({ filter });

		if(!this.state.data[filter]) {
			try {
				const { users_top } = await get('/user/getTop', {
					period: filter,
				});

				this.setState({
					data: {
						...this.state.data,
						[filter]: users_top,
					},
				});
			} catch(err) {
				console.log(err);
			}
		}
	}

	render() {
		const { filter, data } = this.state;

		return (
			<GoalCardWrapper className={cx('main')}>
				<BlockHeader currentItem={filter} onNav={::this.handleNav}>
					{__('goal.most_active')}
				</BlockHeader>

				<div className={cx('list')}>
					{data[filter] && data[filter].map(user =>
						<a href={`/user/${user.id}`} key={user.id} className={cx('item')}>
							<Avatar size="m" user_id={user.id} avatar={user.avatar} />
							<div className={cx('info')}>
								<h4 className={cx('name')}>
									{user.username}
								</h4>
								<p className={cx('metric')}>
									{user.count_posts} {declension(__('posts.word'), user.count_posts)}
								</p>
								<p className={cx('metric')}>
									{user.count_comments} {declension(__('comments'), user.count_comments)}
								</p>
							</div>
						</a>
					)}

					{!data[filter] &&
						<div className={cx('loader')}>
							<Spinner color="#00F4F6" />
						</div>
					}
				</div>
			</GoalCardWrapper>
		);
	}

}



// WEBPACK FOOTER //
// ./src/react/elements/GoalsPage/MostActive.js